import { FormBase } from '@components-common/forms';
import { IRootieComponent } from '@components-common/types';
import { applySpec, propOr } from 'ramda';
import { CreateTemplate, FormConfig } from '../../_types';
import { getEndpoints } from '../utils/get-endpoints';

export const formSpec = (type: string, obj: CreateTemplate) => {
  const result = applySpec<IRootieComponent>({
    id: (cfg: any) => `for_${propOr('NOT_SET', 'id', cfg)}`,
    Component: propOr(FormBase, 'form'),

    type: propOr(type, 'type'),
    cat: (_: FormConfig) => 'form',
    props: {
      empty: propOr(undefined, 'empty'),
      entityId: propOr(undefined, 'entityId'),
      schema: propOr(undefined, 'schema'),
      mode: propOr(undefined, 'mode'),
      endpoints: getEndpoints,
    },
  })(obj);
  return result;
};

export const mapForm = (obj: CreateTemplate, context?: any) => {
  const result = {
    id: `form_${propOr('NOT_SET', 'id', obj)}`,
    cat: 'form',
    type: propOr('NOT_SET', 'id', obj),
    editSource: propOr('', 'editSource', obj), // code added for us to know which endpoint to use for editing
    idPropSource: propOr('id', 'idPropSource', obj), // code added for us to know which prop to use for id in the endpoint
    Component: propOr(FormBase, 'form', obj),
    props: {
      empty: propOr([], 'empty')(obj),
      schema: propOr([], 'schema')(obj),
    },
  };
  return result;
};
